import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import { handleException } from 'modules/account/detail/helpers/utils';
import useService from 'common/hook/useService';

// screen
import { type OrganizationInfo } from 'modules/department/services/useGetOrganizationsList';
import { Unit } from 'modules/account/types';

export interface HvsInfo {
  company: Unit; // Thông tin công ty
  unit: OrganizationInfo; // Thông tin đơn vị
}

/**
 * Thông tin của Hương Việt Sinh
 */
const useGetHvsInfo = () => {
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.kiosHvs],
    queryFn: async () => {
      try {
        if (!service) {
          return { company: undefined, unit: undefined };
        }

        const hvs = await service.KiosController_getHvsInfo();

        const result: HvsInfo = {
          company: {
            id: hvs.operationCode ?? '',
            operationCode: hvs.operationCode ?? '',
            name: hvs.name ?? '',
            ward: hvs.wardName ?? '',
            district: hvs.districtName ?? '',
            city: hvs.cityName ?? '',
          },
          unit: {
            operationCode: hvs.operationCode ?? '',
            name: hvs.name ?? '',
            orgType: 'HVS',
            status: true,
          },
        };
        return result;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useGetHvsInfo;
